<template>
  <div class="pos-sidebar-body">
    <div class="pos-table overflow-auto" data-id="pos-table-info">
      <OrderItem v-for="(item, index) in orderBy(tableSelected.invoice_detail)" :key="index" :item="item"
        :defaultCrrency="defaultCrrency" @removeItem="$emit('removeItem', item)"
        @fetchTableByInterval="$emit('fetchTableByInterval', $event)" :tableSelected="tableSelected" />
    </div>
    <div class="h-100 d-none align-items-center justify-content-center text-center p-20" data-id="pos-table-empty">
      <div>
        <div class="mb-3">
          <svg width="6em" height="6em" viewBox="0 0 16 16" class="text-gray-300" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z" />
            <path d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z" />
          </svg>
        </div>
        <h4>{{ $t('restaurantSale.noTableSelected') }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import OrderItem from './OrderItem.vue'

export default {
  name: 'SidebarBody',
  components: {
    OrderItem
  },
  props: {
    tableSelected: {
      type: Object,
      default: () => ({})
    },
    defaultCrrency: {
      type: String,
      default: ''
    }
  },
  methods: {
    orderBy(items) {
      return orderBy(items, ['display_order'], ['desc'])
    }
  }
}
</script>